import React from 'react';

import {CommonQuestionnaireComponentProps} from '../types';
import QuestionnaireHeader from '../QuestionnaireForm/QuestionnaireHeader';
import QuestionnaireTitle from '../QuestionnaireForm/QuestionnaireTitle';
import QuestionnaireForm from '../QuestionnaireForm/QuestionnaireForm';
import QuestionnaireFooter from '../QuestionnaireForm/QuestionnaireFooter';
import '../styles.scss';

const LifeStyleQuestionnaireComponent: React.FC<
  CommonQuestionnaireComponentProps
> = ({
  formik,
  startIndex,
  totalPages,
  questionsToDisplay,
  currentPage,
  handlePageChange,
  handleBack,
  handleFormSubmit,
  disableSubmit,
}) => {
  return (
    <div className="flex flex-col flex-1 bg-primary font-primary">
      <QuestionnaireHeader
        handleBack={handleBack}
        data-testid="lifestyle-questionnaire-header"
      />
      <div className="flex-1 overflow-y-auto px-10 pt-2">
        <QuestionnaireTitle
          title="Lifestyle questionnaire"
          className="w-auto text-2xl font-semibold leading-7 tracking-tight font-inter text-primary-dark text-left mb-2"
          data-testid="lifestyle-questionnaire-title"
        />
        <QuestionnaireForm
          formik={formik}
          startIndex={startIndex}
          questionsToDisplay={questionsToDisplay}
          layoutClassName="grid grid-cols-1 md:grid-cols-2 gap-4 w-full"
          questionContainerClassName="flex-1 rounded-lg my-6"
          questionClassName="font-inter font-semibold text-xl text-grey-dark leading-7 tracking-tight"
          data-testid="lifestyle-questionnaire-form"
        />
      </div>
      <QuestionnaireFooter
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        handleSubmit={handleFormSubmit}
        isFormValid={formik.isValid}
        disableSubmit={disableSubmit}
        data-testid="lifestyle-questionnaire-footer"
      />
    </div>
  );
};

export default LifeStyleQuestionnaireComponent;
